/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoAnalyticsModelsUserWidgetListItem,
    MelcoAnalyticsModelsUserWidgetListItemFromJSON,
    MelcoAnalyticsModelsUserWidgetListItemFromJSONTyped,
    MelcoAnalyticsModelsUserWidgetListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem
 */
export interface MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem {
    /**
     * 
     * @type {Array<MelcoAnalyticsModelsUserWidgetListItem>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem
     */
    list: Array<MelcoAnalyticsModelsUserWidgetListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItemFromJSON(json: any): MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem {
    return MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoAnalyticsModelsUserWidgetListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItemToJSON(value?: MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoAnalyticsModelsUserWidgetListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


